import React, { FunctionComponent, useCallback } from 'react'
import { Box } from 'transfix-ui/core'
import { FilterInputMatchType } from 'apps/marketplace/pages/shipment-details/components/CarrierCallList/CarrierFilter/FilterInputMatchType'
import {
  IMatchingShipmentsFilters,
  TMatchingShipmentsFilterSetter,
} from './hooks/useMatchingShipmentsFilters'

export interface IMatchingShipmentsFiltersProps {
  filters: IMatchingShipmentsFilters
  setFilter: TMatchingShipmentsFilterSetter
}

export const MatchingShipmentsFilters: FunctionComponent<IMatchingShipmentsFiltersProps> = ({
  filters,
  setFilter,
}) => {
  const handleSelectMatchTypes = useCallback(selected => setFilter('matchTypes', selected), [
    setFilter,
  ])

  return (
    <Box component='section' display='flex' data-test='matching-shipments-filters' flexWrap='wrap'>
      <Box mx={0.5} mb={0.5}>
        <FilterInputMatchType
          onSelectMatchTypes={handleSelectMatchTypes}
          value={filters.matchTypes}
        />
      </Box>
    </Box>
  )
}
